function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());






console.log("Theme JS Loaded");

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        initFindMySize();
    }, 1000);
});

function initFindMySize() {
    const findMySizeButton = document.getElementById("find-my-size-button");
    if (!findMySizeButton) {
        console.log("Find My Size button not found");
        return;
    }

    // Ensure button click is detected
    findMySizeButton.addEventListener("click", () => {
        const modal = document.getElementById("size-quiz-modal");
        if (modal) {
            modal.style.display = "flex";
            resetQuiz();
            renderQuestion();
        }
    });
}

const modal = document.getElementById("size-quiz-modal");
const quizContainer = document.getElementById("quiz-container");
const closeIcon = document.querySelector(".close-icon");

if (closeIcon) {
    closeIcon.addEventListener("click", () => {
        modal.style.display = "none";
        resetQuiz();
    });
}

window.addEventListener("click", (e) => {
    if (e.target === modal) {
        modal.style.display = "none";
        resetQuiz();
    }
});
let currentStep = 0;
let answers = {};
let finalSize = null;

const sizeMappingCm = {
    "40": [24.6, 25.1],
    "41": [25.2, 25.8],
    "42": [25.9, 26.4],
    "43": [26.5, 27.2],
    "44": [27.3, 27.7],
    "45": [27.8, 28.4],
    "46": [28.5, 29.2],
    "47": [29.3, 30.1],
};

const quizData = [
    { question: "Select one:", options: ["US", "UK", "EU"], key: "region" },
    { 
        question: "Which size do you wear?", 
        options: () => {
            return answers.region === "EU" 
                ? Array.from({ length: 15 }, (_, i) => (40 + i * 0.5).toFixed(1)) 
                : Array.from({ length: 16 }, (_, i) => (5.5 + i * 0.5).toFixed(1));
        },
        key: "shoeSize"
    },
    { 
        question: "Do you ever wear other sizes?", 
        options: () => {
            const selectedSize = parseFloat(answers.shoeSize) || 40;
            return [
                `I sometimes wear size ${selectedSize}`,
                `I always wear size ${selectedSize}`,
                `I sometimes wear size ${(selectedSize + 0.5).toFixed(1)}`,
            ];
        },
        key: "otherSizes"
    },
    { 
        question: "Is your foot narrow, normal, or wide?", 
        options: ["Narrow", "Normal", "Wide"], 
        key: "footWidth"
    },
    {
        question: "Select your size in cm:",
        options: Object.values(sizeMappingCm).map(range => `${range[0]} - ${range[1]} cm`),
        key: "sizeInCm",
        skip: true,
    }
];

const renderQuestion = () => {
    if (!quizContainer) return;

    const questionData = quizData[currentStep];
    const options = typeof questionData.options === "function" ? questionData.options() : questionData.options;

    quizContainer.innerHTML = `
        <h3>${questionData.question}</h3>
        <div class="quiz-options">
            ${options.map((option, index) => `<div class="quiz-option" data-index="${index}">${option}</div>`).join("")}
        </div>
        ${questionData.skip ? '<button class="skip-button">Skip</button>' : ""}
        <div class="navigation-buttons">
            <button class="quiz-button back-button" ${currentStep === 0 ? 'style="display: none;"' : ''}>Back</button>
            <button class="quiz-button next-button" disabled>Next</button>
        </div>
    `;

    const backButton = document.querySelector(".back-button");
    const nextButton = document.querySelector(".next-button");

    document.querySelectorAll(".quiz-option").forEach(button => {
        button.addEventListener("click", (e) => {
            answers[questionData.key] = e.target.innerText;

            document.querySelectorAll(".quiz-option").forEach(btn => btn.classList.remove("selected"));
            e.target.classList.add("selected");

            nextButton.disabled = false; // ✅ Enable Next button after selection

            setTimeout(() => goToNextQuestion(), 300);
        });
    });

    if (questionData.skip) {
        document.querySelector(".skip-button").addEventListener("click", () => {
            calculateFinalSize(true);
        });
    }

    if (backButton) backButton.addEventListener("click", goToPreviousQuestion);
    if (nextButton) nextButton.addEventListener("click", goToNextQuestion);
};

const goToNextQuestion = () => {
    currentStep++;
    if (currentStep >= quizData.length) {
        calculateFinalSize(false);
    } else {
        renderQuestion();
    }
};

const goToPreviousQuestion = () => {
    if (currentStep > 0) {
        currentStep--;
        renderQuestion();
    }
};

const calculateFinalSize = (isSkip) => {
    let size = parseFloat(answers.shoeSize) || 40;

    if (answers.footWidth) {
        if (answers.footWidth === "Narrow") size -= 0.5;  // ✅ Subtract 0.5 for Narrow
        if (answers.footWidth === "Wide") size += 0.5;    // ✅ Add 0.5 for Wide
    }

    if (answers.sizeInCm && !isSkip) {
        const selectedCmSize = Object.entries(sizeMappingCm).find(([size, range]) => 
            answers.sizeInCm.includes(`${range[0]} - ${range[1]}`)
        );

        if (selectedCmSize) {
            finalSize = selectedCmSize[0];
        }
    } else {
        finalSize = size.toFixed(1);
    }

    quizContainer.innerHTML = `
        <h3>We recommend size ${finalSize} for you!</h3>
              <img class="shoe-image" src="https://cdn.shopify.com/s/files/1/0895/6890/3473/files/Untitled_design_9.png?v=1737528786">

        <div class="navigation-buttons">
            <button class="quiz-button restart-button">Restart Quiz</button>
            <button class="quiz-button close-button">Close</button>
        </div>
    `;

    const restartButton = document.querySelector(".restart-button");
    const closeButton = document.querySelector(".close-button");

    restartButton.addEventListener("click", () => {
        resetQuiz();
        renderQuestion();
    });

    closeButton.addEventListener("click", () => {
        modal.style.display = "none";
        resetQuiz();
    });

    document.querySelector(".back-button").style.display = "none";
    document.querySelector(".next-button").style.display = "none";
};

const resetQuiz = () => {
    currentStep = 0;
    answers = {};
    finalSize = null;
    quizContainer.innerHTML = "";
};
